// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0ecec5cf","453":"7e5980d4","732":"f3157ace","977":"eed6cbfd"}[chunkId] + ".chunk.js";
};